import React, { useState } from 'react';
import MobileHeader from './MobileHeader';
import MobileChatInterface from './MobileChatInterface';
import MobilePDFViewer from './MobilePDFViewer';
import './MobileLayout.css';

interface Message {
  id: string;
  type: 'question' | 'answer';
  content: string;
  timestamp: Date;
}

interface MobileLayoutProps {
  currentDocument?: string;
  messages: Message[];
  onSendMessage: (message: string) => void;
  onGenerateSummary: () => void;
  onShowSuggestions: () => void;
  onViewPDF: () => void;
  onSearchDocument: () => void;
  pdfUrl?: string;
}

const MobileLayout: React.FC<MobileLayoutProps> = ({
  currentDocument,
  messages,
  onSendMessage,
  onGenerateSummary,
  onShowSuggestions,
  onViewPDF,
  onSearchDocument,
  pdfUrl
}) => {
  const [isPDFOpen, setIsPDFOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleViewPDF = () => {
    setIsPDFOpen(true);
    onViewPDF();
  };

  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleDocumentClick = () => {
    // Toggle document list or show document picker
    console.log('Document clicked');
  };

  const handleChatClick = () => {
    // Focus on chat interface
    console.log('Chat clicked');
  };

  const handleSettingsClick = () => {
    // Open settings
    console.log('Settings clicked');
  };

  return (
    <div className="mobile-layout">
      {/* Mobile Header */}
      <MobileHeader
        onMenuClick={handleMenuClick}
        onDocumentClick={handleDocumentClick}
        onChatClick={handleChatClick}
        onSettingsClick={handleSettingsClick}
        currentDocument={currentDocument}
      />

      {/* Mobile Chat Interface */}
      <MobileChatInterface
        messages={messages}
        onSendMessage={onSendMessage}
        onGenerateSummary={onGenerateSummary}
        onShowSuggestions={onShowSuggestions}
        onViewPDF={handleViewPDF}
        onSearchDocument={onSearchDocument}
      />

      {/* Mobile PDF Viewer */}
      <MobilePDFViewer
        isOpen={isPDFOpen}
        onClose={() => setIsPDFOpen(false)}
        pdfUrl={pdfUrl}
        documentTitle={currentDocument}
      />

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setIsMenuOpen(false)}>
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <div className="menu-header">
              <h3>Menu</h3>
              <button className="close-menu-btn" onClick={() => setIsMenuOpen(false)}>
                ×
              </button>
            </div>
            <div className="menu-items">
              <button className="menu-item">📄 Documents</button>
              <button className="menu-item">💬 Chat History</button>
              <button className="menu-item">📊 Summaries</button>
              <button className="menu-item">⚙️ Settings</button>
              <button className="menu-item">❓ Help</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileLayout; 